/**
 * Ensure that all inputs and widgets on the page have a unique ID.
 * This is important when opening dialogs where it is quite common to have a page loaded
 * into a dialog that has the same ID as a field on the parent page or another open dialog.
 */
(function($) {

	$.fn.uniqueFormInputIds = function() {

		return this.each(function() {
			var $this = $(this);

            var uniqueIds = [];
            var $inputs = $this.find(':input,.combobox,.dropdownlist');

            // find all existing IDs for inputs and widgets that are not descendants of $this
            $(':input,.jqx-widget').not($inputs).each(function(){
                if($(this).attr('id')) {
                    uniqueIds.push($(this).attr('id'));
                }
            });

            // ensure all inputs and widgets that are descendents of $this have a unique ID
            $inputs.each(function(){
                var $input = $(this);
                var id = $input.attr('id');
                if(id) {
                    if(uniqueIds.indexOf(id) > -1) {
                        var $label = $input.closest('.form-row').find('label[for="'+id+'"]');
                        id = id + '_' + uniqueIds.length;
                        $input.attr('id', id);
                        if ($label.size()>0) {
                            $label.attr('for', id);
                        }
                    }
                    uniqueIds.push(id);
                }
            });
        });
	};

})(jQuery);